var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('div',{staticClass:"player embed-responsive-item",attrs:{"id":"player"}})])
}]

export { render, staticRenderFns }